export default "__VITE_ASSET__B5lEp$qP__"